import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_GIF,
  ACTIVITIES_COMPONENT_TYPE_IMAGE,
  ACTIVITIES_COMPONENT_TYPE_INFO_BOX,
} from 'global/constants';
import InfoBoxView from './components/info-box/info-box-view';
import {
  ComponentDraw,
  ComponentInfoBox,
  ComponentResponse,
} from './components/component.constants';
import { Props } from './activity-builder-zoom-component-modal.constants';
import { FlexRightAlign } from 'approot/shared/styles/flex.style';
import IconClose from 'approot/shared/icons/icon-close';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import ActivityBuilderImageLightbox from './lightbox/activity-builder-image-lightbox';
import ResponsePrint from './components/response/response-print';
import { TooltipIconWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import ActivityBuilderDrawLightbox from './lightbox/activity-builder-draw-lightbox';
import IconExpand from 'approot/shared/icons/icon-expand';
import IconListen from 'approot/shared/icons/icon-listen';
import { ValidSpacings } from 'approot/shared/styles/spacing.style';
import ActivitySheet from './components/shared/sheet/activity-sheet';
import * as Styled from './activity-builder-zoom-component-modal.style';

const ActivityBuilderZoomComponentModal = ({
  closeModal,
  isStudent,
  component,
}: Props) => {
  if (
    component.type === ACTIVITIES_COMPONENT_TYPE_IMAGE ||
    component.type === ACTIVITIES_COMPONENT_TYPE_GIF
  ) {
    return (
      <ActivityBuilderImageLightbox
        sectionId={component.sectionId}
        selected={component}
        isStudent={isStudent}
        onClose={closeModal}
      />
    );
  }

  return (
    <ActivitySheet
      isVisible
      title="Zoom component"
      hasBackgroundColor
      data-selector="react-modal-window-present"
      onClose={closeModal}
    >
      {component.type === ACTIVITIES_COMPONENT_TYPE_DRAW ? (
        <ActivityBuilderDrawLightbox {...(component as ComponentDraw)} />
      ) : (
        <Styled.ZoomComponentContent>
          <Styled.ZoomComponentContentInner>
            {component.type === ACTIVITIES_COMPONENT_TYPE_INFO_BOX && (
              <InfoBoxView {...(component as ComponentInfoBox)} isZoomed />
            )}
            {component.type ===
              ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE && (
              <ResponsePrint {...(component as ComponentResponse)} isZoomed />
            )}
          </Styled.ZoomComponentContentInner>
        </Styled.ZoomComponentContent>
      )}
    </ActivitySheet>
  );
};

export const ZoomComponentTrigger = ({
  ariaLabel,
  openModal,
  canAddResponse,
  hoverText = 'Expand',
  hideBorder,
  onComponentExpand,
}: {
  ariaLabel?: string;
  openModal: () => void;
  canAddResponse?: boolean;
  hoverText?: string;
  hideBorder?: boolean;
  onComponentExpand?: () => void;
}) => (
  <Styled.ZoomComponentWrapper>
    <Styled.ZoomComponentTooltip>
      <TooltipWrapper
        hoverText={hoverText}
        svgContent={
          <TooltipIconWrapperStyled>
            <IconExpand width={20} height={20} />
            {canAddResponse && (
              <ActivityBuilderInlineSvg
                id="icon_pencil"
                width={20}
                height={20}
              />
            )}
          </TooltipIconWrapperStyled>
        }
      >
        <Styled.ZoomComponentTrigger
          type="button"
          aria-haspopup
          aria-label={ariaLabel}
          onClick={() => {
            onComponentExpand?.();
            openModal();
          }}
          $hideBorder={hideBorder}
          data-testid="zoom-component-trigger"
          data-selector="component-present"
        />
      </TooltipWrapper>
    </Styled.ZoomComponentTooltip>
  </Styled.ZoomComponentWrapper>
);

export const TTSComponentTrigger = ({
  onClick,
  isActive,
  ariaLabel,
}: {
  onClick: () => void;
  isActive?: boolean;
  ariaLabel?: string;
}) => {
  const label =
    ariaLabel ||
    (isActive
      ? 'Hide text to speech controls'
      : 'Show text to speech controls');

  return (
    <Styled.ZoomComponentWrapper>
      <Styled.ZoomComponentTooltip>
        <TooltipWrapper
          hoverText={label}
          forceBelow={isActive}
          svgContent={
            <TooltipIconWrapperStyled>
              <IconListen width={20} height={20} />
            </TooltipIconWrapperStyled>
          }
        >
          <Styled.ZoomComponentTrigger
            type="button"
            aria-label={label}
            onClick={onClick}
            data-testid="tts-component-trigger"
            data-selector="component-present"
          />
        </TooltipWrapper>
      </Styled.ZoomComponentTooltip>
    </Styled.ZoomComponentWrapper>
  );
};

export const ZoomComponentModalCloseButton = ({
  marginBottom = 16,
  onClick,
}: {
  marginBottom?: ValidSpacings;
  onClick: () => void;
}) => (
  <FlexRightAlign $marginBottom={marginBottom}>
    <Styled.ZoomComponentModalClose
      type="button"
      aria-label="close"
      data-selector="close-modal"
      onClick={onClick}
    >
      <IconClose width={16} height={16} />
    </Styled.ZoomComponentModalClose>
  </FlexRightAlign>
);

export default ActivityBuilderZoomComponentModal;
